import Vue from 'vue';
import axios from 'axios';
import '../../../filters';
import moment from 'moment';
import elementsType from '../elementsType/elementsType';


export default {
  name: 'elementProperties',
  components: {
    TreeSelect: require('../../../customcontrols/selectOfTree.vue').default,
  },
  props: {
    elementTypeId: {
      type: Number,
      required: true
    },
    elementId: {
      type: Number,
      required: true
    },
    readonly: {
      type: Boolean,
      default: true
    },
    showClose: {
      type: Boolean,
      default: true
    }
  },
  data: function () {
    return {
      thisPage: null,
      elementName: '',
      elementProperties: null,
    }
  },
  computed: {
    
  },
  watch: {
    
  },
  created() {
    this.thisPage = this;
    this.$material.locale.dateFormat = 'yyyy-MM-dd';
    this.viewProperties();
  },
  mounted() {
    
  },
  methods: {
    viewProperties() {
      if (this.elementTypeId == '' || this.elementTypeId == null || this.elementId == '' || this.elementId == null)
        return;

      const parameters = {
        elementTypeId: this.elementTypeId,
        elementId: this.elementId
      };

      this.$store.state.notifier.asyncBlock(
        axios.get('/Element/GetElementProperties', { params: parameters }),
        response => {
          if (response.status == 200) {
            Object.keys(response.data.item.properties).map((key) => {
              for (var i = 0; i < response.data.item.properties[key].length; i++) {
                if (response.data.item.properties[key][i].type == 5) {
                  response.data.item.properties[key][i].valueDisplay = moment(response.data.item.properties[key][i].value).format('YYYY-MM-DD');
                }
              }
            });

            this.elementName = response.data.name;
            this.elementProperties = response.data.item;
          }
        },
        error => {
          this.$alertMsg(error.response.data);
        }
      );
    },
    setElementProperties() {
      let properties = [];

      Object.keys(this.elementProperties.properties).map((key) => {
        for (var i = 0; i < this.elementProperties.properties[key].length; i++) {
          if (this.elementProperties.properties[key][i].type == 4) {
            if (this.elementProperties.properties[key][i].value.filter(a => a.selected).length > 0) {
              properties.push({
                id: this.elementProperties.properties[key][i].id,
                name: this.elementProperties.properties[key][i].name,
                type: this.elementProperties.properties[key][i].type,
                value: this.elementProperties.properties[key][i].value.filter(a => a.selected)[0].value
              });
            }
          }
          else if (this.elementProperties.properties[key][i].type == 5) {
            properties.push({
              id: this.elementProperties.properties[key][i].id,
              name: this.elementProperties.properties[key][i].name,
              type: this.elementProperties.properties[key][i].type,
              value: this.elementProperties.properties[key][i].value + 'T00:00:00'
            });
          }
          else {
            properties.push(this.elementProperties.properties[key][i]);
          }
        }
      });

      const parameters = {
        ElementTypeId: this.elementTypeId,
        ElementId: this.elementId,
        Properties: properties,
      };

      this.$store.state.notifier.asyncBlock(
        axios.post('/Element/SetElementProperties', parameters),
        response => {
          if (response.status == 200) {
            this.$alertMsg(this.$t('assets.elementPropertiesHaveBeenSavedSuccessfully'), 2);
            this.closeDialog();
          }
        },
        error => {
          this.$alertMsg(error.response.data);
        },
        this.$t('common.saving')
      );
    },
    fillList(list) {
      var selectList = [];

      for (var i = 0; i < list.length; i++) {
        selectList.push({
          id: list[i].value,
          label: list[i].text,
          group: list[i].group,
          selected: list[i].selected,
        });
      }

      return selectList;
    },
    onItemSelected(group, rowIndex, item) {
      for (var i = 0; i < this.elementProperties.properties['' + group + ''][rowIndex].value.length; i++) {
        this.elementProperties.properties['' + group + ''][rowIndex].value[i].selected = false;

        if (this.elementProperties.properties['' + group + ''][rowIndex].value[i].value == item.id)
          this.elementProperties.properties['' + group + ''][rowIndex].value[i].selected = true;
      }
    },
    closeDialog() {
      this.$emit('closeDialog');
    }
  },
}
